import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'lib-custom-switch',
  templateUrl: './custom-switch.component.html',
  styleUrls: ['./custom-switch.component.scss']
})
export class CustomSwitchComponent implements OnInit {

  
  @Input() switchValue = false;
  @Input() activeLabel = 'Si';
  @Input() inactiveLabel = 'No';
  @Output() switchValueEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}

  changeSwitch() {
    this.switchValueEvent.emit(this.switchValue);
  }

}
